import MDTypography from "components/MDTypography";
import { IconButton, Box } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import AuthenticationService from "application/modules/authentication/AuthenticationService";

function CTLClickToCall({ value, row, onCall }) {
  const shouldShowIcon =
    value && AuthenticationService.getExtensionNumber() !== value;

  return (
    <Box display="flex" alignItems="center">
      {shouldShowIcon ? (
        <IconButton color="info" onClick={() => onCall && onCall(value, row)}>
          <CallIcon />
        </IconButton>
      ) : (
        <Box width={40} />
      )}
      <MDTypography variant="caption" fontWeight="medium" color="text">
        {value}
      </MDTypography>
    </Box>
  );
}

CTLClickToCall.defaultProps = {
  suffix: "",
};

export default CTLClickToCall;
